import type { FandomContext } from "common-types";

export function getTop1kWikiString(
  fandomContext: FandomContext | null,
): string {
  return fandomContext?.site?.top1000 ? "_top1k_wiki" : "_not_a_top1k_wiki";
}
